import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

//TODO: Ask Higor
export const useStyles = makeStyles((theme: Theme) => ({
	sectionInfo: {
		display: "flex",
		flexDirection: "column",
		width: "35%",
		[theme.breakpoints.down("xl")]: {
			flexDirection: "row",
			width: "100%",
		},
		"&.sectionInfoModal": {
			flexDirection: "row",
			width: "100%",
			[theme.breakpoints.down("xl")]: {
				flexDirection: "column",
			},
		},
	},
	demandCovInfo: {
		display: "flex",
		[theme.breakpoints.down("xl")]: {
			width: "35%",
		},
		"&.demandCovInfoModal": {
			width: "40%",
			[theme.breakpoints.down("xl")]: {
				width: "100%",
			},
		},
	},
	superiorityFactorInfo: {
		display: "flex",
		padding: "0 16px",
		marginTop: "8px",
		[theme.breakpoints.down("xl")]: {
			width: "40%",
			marginTop: "0px",
			alignItems: "center",
		},
		"&.superiorityFactorInfoModal": {
			width: "60%",
			marginTop: "0px",
			alignItems: "center",
			[theme.breakpoints.down("xl")]: {
				width: "100%",
				marginTop: "8px",
			},
		},
	},
	superiorityFactorTextContainer: {
		display: "flex",
		alignItems: "center",
		marginLeft: "20px",
		width: "80%",
		[theme.breakpoints.down("xl")]: {
			width: "100%",
		},
		"&.superiorityFactorTextContainerModal": {
			width: "100%",
		},
	},
	sbIcon: {
		"& path": {
			fill: theme.palette.primary.main,
		},
	},
}));
